export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=31927892&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/pages/lk/price-lists/index.vue?vue&type=template&id=31927892&
// module id = 1422
// module chunks = 0